import { usePunditUserContext } from "@circle-react/contexts";
import { useThemeContext } from "@circle-react/providers";

export const useCommunityIconUrl = () => {
  const {
    currentCommunity: {
      icon_url: lightIconUrl,
      dark_icon_url: darkIconUrl,
    } = {},
  } = usePunditUserContext();

  const { isDarkAppearance } = useThemeContext();
  return isDarkAppearance ? darkIconUrl || lightIconUrl : lightIconUrl;
};
